import { render, staticRenderFns } from "./coinCard.vue?vue&type=template&id=d12760cc&scoped=true"
import script from "./coinCard.vue?vue&type=script&lang=ts"
export * from "./coinCard.vue?vue&type=script&lang=ts"
import style0 from "./coinCard.vue?vue&type=style&index=0&id=d12760cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12760cc",
  null
  
)

export default component.exports